export default __webpack_public_path__ + "static/media/Ramps.256.02600019.png";